/**
 * Delivery Estimate Widget
 */
import React from "react";
import { useDeliveryEstimateAnalytics, useDeliveryEstimatesImpressionAnalytics, } from "@catchoftheday/analytics";
import { ContentPlaceHolder } from "@catchoftheday/cg-components";
import { useDeliveryEstimateWidgetQuery } from "../../generated/graphql.jsx";
import { DeliveryEstimateError } from "../DeliveryEstimateError/index.js";
import { DeliveryEstimateMessage } from "../DeliveryEstimateMessage/index.js";
export function DeliveryEstimateWidget({ offerId, postcode, externalLoading = false, }) {
    const { data, error: queryError, loading, } = useDeliveryEstimateWidgetQuery({
        variables: {
            offerId,
            postcode,
        },
    });
    // Has valid delivery estimate
    const deliveryEstimate = !!data && "deliveryEstimate" in data.deliveryEstimate
        ? data.deliveryEstimate.deliveryEstimate
        : null;
    // Item cannot be delivery to the selected location
    const deliveryEstimateError = !!data && "error" in data.deliveryEstimate
        ? data.deliveryEstimate.error
        : null;
    useDeliveryEstimateAnalytics({
        enabled: !!deliveryEstimate,
        context: {
            ...(deliveryEstimate || {}),
            postcode: data?.deliveryEstimate.postcode,
            // Default to Standard as we only provide estimates for Standard
            deliveryType: "STANDARD",
            // Default to IN_STOCK as it can only differ in Cart
            parcelType: "IN_STOCK",
        },
        options: {
            fireOnFallback: true,
        },
    });
    const { ref: deliveryEstimateMessageRef } = useDeliveryEstimatesImpressionAnalytics({
        enabled: !!deliveryEstimate,
        context: {
            labelType: "label",
            offerId,
            postcode,
        },
    });
    if (externalLoading || loading) {
        return (<ContentPlaceHolder speed={2} width="100%" viewBox="0 0 230 32" backgroundColor="#f3f3f3" foregroundColor="#ecebeb" aria-label="Loading">
        <rect x="0" y="0" rx="3" ry="3" width="100%" height="32"/>
      </ContentPlaceHolder>);
    }
    if (queryError) {
        return <DeliveryEstimateError />;
    }
    if (deliveryEstimateError) {
        return <DeliveryEstimateError message={deliveryEstimateError.message}/>;
    }
    if (!deliveryEstimate) {
        return null;
    }
    return (<DeliveryEstimateMessage ref={deliveryEstimateMessageRef} deliveryEstimate={deliveryEstimate}/>);
}
